// extracted by mini-css-extract-plugin
export default {"agentRoleWrapper":"styles_agentRoleWrapper__QSaRk","arrowIcon":"styles_arrowIcon__GuQXX","agentRoleConfirmText":"styles_agentRoleConfirmText__Q7w0J"};